import React from "react";
import NebulaModal from "./NebulaModal";
import { showError } from "@/utils/toastUtils";
import { useGetDecisionDetailQuery } from "../../../api/nebula-stats/nebulaStatsApi";
import { reformatDate } from "../utils/dateUtils";
import { DECISION_TYPE_LABEL } from "../utils/nebulaData";
import { getDecisionHeading } from "../utils/nebulaUtils";
import BlockNoteRenderer from "./BlockNoteRenderer";
import { EmptyState } from "./EmptyState";
import Spinner from "./Spinner";

const DecisionPlanModal = ({ planId, onClose }) => {
  const { data, isFetching, isError } = useGetDecisionDetailQuery(planId, {
    skip: planId == null,
  });

  React.useEffect(() => {
    if (isError) showError("Không thể tải kế hoạch");
  }, [isError]);

  const dataPlan = React.useMemo(() => {
    const plan = data?.data;
    const blocks = Array.isArray(plan?.blocks) ? plan.blocks : [];
    return {
      plan,
      blocks,
      tradeTime: plan?.tradeDate ? reformatDate(plan.tradeDate, "HH:mm") : "",
      tradeDate: plan?.tradeDate
        ? reformatDate(plan.tradeDate, "DD/MM/YYYY")
        : "",
      heading:
        getDecisionHeading(blocks) || DECISION_TYPE_LABEL[plan?.type] || "",
    };
  }, [data?.data]);

  return (
    <NebulaModal
      open={planId != null}
      onClose={onClose}
      title="Xem kế hoạch"
      align="center"
      classNames={{
        root: "!max-w-[448px] !overflow-hidden",
        body: "max-h-[80vh] overflow-y-auto thin-scrollbar",
        header: "mb-[16px]",
      }}
    >
      {isFetching && (
        <div className="flex items-center justify-center py-[40px] h-[412px]">
          <Spinner />
        </div>
      )}

      {!isFetching && dataPlan.plan && (
        <>
          {dataPlan.tradeDate && (
            <div className="text-[12px] leading-[16px] text-[#636369] mb-[4px]">
              {dataPlan.tradeDate}
            </div>
          )}
          {dataPlan.heading && (
            <span className="text-[14px] font-[700] text-[#111827] mb-[4px] block">
              {dataPlan.heading}
            </span>
          )}
          <BlockNoteRenderer
            blocks={dataPlan.blocks.filter(
              (block) =>
                !(block.type === "heading" && block.props?.level === 2),
            )}
          />
        </>
      )}

      {!isFetching && !dataPlan.plan && isError && (
        <EmptyState variant="padded" text="Không thể tải kế hoạch." />
      )}
    </NebulaModal>
  );
};

export default DecisionPlanModal;
